var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "wf-ideabook-previous-issues py-5" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("h3", [
        _vm._v(_vm._s(_vm.ideabookdetail.parent.ideabookFolderDownloadsTitle))
      ]),
      _vm._v(" "),
      _c("p", {
        domProps: {
          innerHTML: _vm._s(
            _vm.ideabookdetail.parent.ideabookFolderDownloadsDescription
          )
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "wf-ideabook-downloads" }, [
        _c("div", { staticClass: "form-row flex-column flex-sm-row mb-4" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "col" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedIdeabookIndex,
                    expression: "selectedIdeabookIndex"
                  }
                ],
                staticClass: "custom-select",
                attrs: { id: "ideabook-downloads-select" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selectedIdeabookIndex = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              _vm._l(_vm.ideabooks, function(ideabook, index) {
                return _c(
                  "option",
                  { key: index, domProps: { value: index } },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(ideabook.name) +
                        "\n            "
                    )
                  ]
                )
              }),
              0
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "wf-ideabook-downloads-box" }, [
          _c(
            "div",
            { staticClass: "description font-weight-bold text-uppercase mb-4" },
            [
              _vm._v(
                "\n          Ideabook / " +
                  _vm._s(_vm.ideabooks[_vm.selectedIdeabookIndex].name) +
                  ":\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass:
                "btn btn-white border border-dark justify-content-start",
              attrs: {
                href: _vm.ideabooks[_vm.selectedIdeabookIndex].url,
                target: "_blank"
              }
            },
            [
              _c("span", {
                staticClass: "png-icon png-icon-icons-glyph--k-btn-download"
              }),
              _vm._v(" "),
              _c("span", { staticClass: "ml-2" }, [_vm._v(" Download PDF ")])
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-auto" }, [
      _c(
        "label",
        {
          staticClass: "input-label",
          attrs: { for: "ideabook-downloads-select" }
        },
        [_vm._v("\n            Publication:\n          ")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }